import React from 'react';
import Layout from "../layout";
import QuestionsList from '../../components/questions/list';

const QuestionsScreen = () => {

  return (
    <Layout controllerName='Perguntas Frequentes' breadcrumb='Dashbord / Perguntas Frequentes'>
      <QuestionsList />
    </Layout>
  )

}

export default QuestionsScreen;

